import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderAccounting, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0740. 発注案件管理会計編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_accountings/:purchase_order_accounting_id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  purchase_order_accounting_id: number;
  monthly_amount?: number;
  spot_amount?: number;
};
const updatePurchaseOrderAccounting = (props: Props): Promise<PurchaseOrderAccounting> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_accountings/${props.purchase_order_accounting_id}`,
    props
  );
};

export const useUpdatePurchaseOrderAccounting = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderAccounting,
  });
};
